export const YES_NO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const SAVE_PROBABILITY_OPTIONS = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
];

export const CSM_SCORE_OPTIONS = [
  { value: "Negative", label: "Negative" },
  { value: "Neutral", label: "Neutral" },
  { value: "Positive", label: "Positive" },
];

export const OTHER_CHURN_REASON = "Other";

export const CHURN_REASON_OPTIONS = [
  { value: "Price/Budget", label: "Price/Budget" },
  {
    value: "In House Team (Bookkeeping/Tax)",
    label: "In House Team (Bookkeeping/Tax)",
  },
  {
    value: "Business closure/Dissolution",
    label: "Business closure/Dissolution",
  },
  {
    value: "Product fit/Missing features",
    label: "Product fit/Missing features",
  },
  {
    value: "Usage/Adoption challenges",
    label: "Usage/Adoption challenges",
  },
  { value: "Cancelled by AM", label: "Cancelled by AM" },
  {
    value: "None - Outside our scope at the moment",
    label: "None - Outside our scope at the moment",
  },
  { value: "Competition", label: "Competition" },
  { value: OTHER_CHURN_REASON, label: "Other" },
];
